<div class="url-input-container">
  <div class="url-input-row">
    <button
      type="button"
      class="p-button p-button-sm p-button-primary"
      (click)="addUrl()"
    >
      {{ addUrlLabel }}
    </button>
    <input
      type="text"
      [(ngModel)]="newUrl"
      [placeholder]="placeholder"
      class="p-inputtext p-component"
    />
  </div>

  <ul class="url-list">
    @for (url of urlList; let i = $index; track url) {
      <li>
        <a [href]="url" target="_blank" rel="noopener noreferrer">{{ url }}</a>
          <button
            type="button"
            class="p-button p-button-sm p-button-danger"
            (click)="confirmRemove(i)">
            Remove
          </button>
      </li>
    }
  </ul>

<p-dialog
  [(visible)]="showUrlDeleteDialog"
  [modal]="true"
  [dismissableMask]="false" 
  appendTo="body"  
  [baseZIndex]="10000"
  [style]="{ width: 'min(90vw, 420px)' }"
  contentStyleClass="custom-confirm-dialog"
  (onHide)="cancelUrlDeletion()"
>
  <div class="dialog-content">
    <i class="pi pi-exclamation-triangle warning-icon"></i>
    <span class="dialog-message">
      Are you sure you want to remove this link?
    </span>
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"    
        class="no-button"
        label="No"
        (click)="cancelUrlDeletion()"
      ></button>

      <button
        pButton
        type="button"    
        class="yes-button"
        label="Yes"
        (click)="confirmUrlDeletion()"
      ></button>
    </div>
  </ng-template>
</p-dialog>

</div>
